export default __webpack_public_path__ + "static/media/ukrainian.cdb2eaf1.jpg";